import type Report from '../index';

abstract class Plugin {
  protected instance: Report;
  abstract name: string;

  constructor(_instance: Report) {
    this.instance = _instance;
    this.init();
  }

  // 监听事件
  listen(event: string, params?: Record<string, any>) {
    if (Reflect.has(this, `on${event}`)) {
      Reflect.apply((this as any)[`on${event}`], this, [params]);
    }
  }

  abstract init(): void;
}

export default Plugin;
